import { Row, Col, Divider } from 'antd';
import { ssFormUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import ProviderRegForm from 'components/forms/registration/ProviderRegForm';
import { RegistrationStatus } from '@bit/ui-common.ui-components/ss-components';
import * as formConfig from 'components/forms/registration/formConfig';
import { providerRegConfig as config } from '../../components/forms/registration/formConfig';
import { AFSP } from '../../../utils/reqUtils';
import { APP } from '../../redux/actions/appActions';

const
{ key } = config,
{ generateInitState } = ssFormUtils,
{ setEnvPrefix } = ssCommonUtils,
{ RESET } = APP.REQUEST.REGISTRATION;

export default class Provider extends React.Component {
    constructor(props) {
        super(props);
        this.buildAllFormStates();
    }

    buildAllFormStates() {
        const
        { state, services } = this.props,
        { registrationForm } = state,
        { storeForm } = services,
        formConfigList = [ formConfig.providerRegConfig ];

        for(let k in formConfigList)
            if(!registrationForm[formConfigList[k].key])
                storeForm(formConfigList[k].key, generateInitState(formConfigList[k]));
    }

    render() {
        const
        { PROVIDER_REGISTRATION } = AFSP.TYPE,
        { state, services } = this.props,
        { captcha, app, registrationForm, provider } = state,
        { registration } = app.request,
        regStatus = registration.status,
        regCode = registration.code;

        return (
            <div className='centered-content' style={{ width: '1000px' }}>
                <RegistrationStatus
                    type='provider'
                    visible={provider.showCaptcha}
                    status={
                        regStatus === 'pending' ||
                        regStatus === 'success' ||
                        regStatus === 'none'
                            ? regStatus
                            : regCode
                    }
                    failureCallback={code => {
                        switch(code) {
                            case 409:
                                services.toggleProviderCaptchaView();
                                services.toggleInvalidProviderEmailError();
                                services.markFieldErrorCode(409, 'provider', 'emailAddress');
                                services.setData(RESET);
                                services.resetCaptchaValidation();
                                break;
                            case 418:
                                services.toggleProviderCaptchaView();
                                services.toggleProviderFAACertError(); 
                                services.markFieldErrorCode(418, 'provider', 'faaCert');
                                services.setData(RESET);
                                services.resetCaptchaValidation();
                                break;
                                   
                            default: window.location.href = setEnvPrefix('/home');
                        }
                    }}
                    captcha={captcha}
                    captchaServices={{
                        validateCaptcha: services.validateCaptcha,
                        checkCaptcha: services.checkCaptcha,
                        updateCaptchaField: services.updateCaptchaField,
                        loadCaptcha: services.loadCaptcha,
                        resetCaptchaValidation: services.resetCaptchaValidation
                    }}
                    doRequestAccount={(captchaInput) => {
                        services.submitProviderRegistrationRequest(registrationForm[key], captchaInput);
                    }}
                    doBack={() => {
                        services.toggleProviderCaptchaView();
                        services.resetCaptchaValidation();
                    }}
                />
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={23}>
                        <div className='home-card' style={{ margin: '20px' }}>
                            <Divider style={{ fontSize: '16px', margin: '0px 0px 20px 0px' }}>
                                <span className='home-prov-reg-title'>
                                    {'Request a New Flight Training Provider Account'}
                                </span>
                            </Divider>
                            <ProviderRegForm sref='provider' {...this.props} />
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}
